<template>
  <div ref="loading-item" class="a-loading-item">
    <div class="a-loading-item__wrapper">
      <div
        class="a-loading-item__container"
        :data-variableImageHeight-container="''"
      >
        <div>
          <div variable-image-height="true">
            <img
              class="a-loading-item__img"
              :style="{ height: getRandomHeight() }"
            />
          </div>
        </div>
      </div>
      <div
        class="a-loading-item__heading"
        :style="{ width: getRandomWidth() }"
      ></div>
      <div
        class="a-loading-item__subheading"
        :style="{ width: getRandomWidth() }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingImageAndCaption",
  data() {
    return {
      /**
       * Max height of loading image
       */
      maxHeight: 320
    };
  },
  methods: {
    /**
     * Get random pixel width that's at least 50%
     *
     * @returns {string}
     **/
    getRandomHeight() {
      let randomNum =
        Math.floor(Math.random() * (this.maxHeight / 2)) + this.maxHeight / 2;
      return `${randomNum}px`;
    },
    /**
     * Get random percent for height that's at least 50%
     *
     * @returns {string}
     **/
    getRandomWidth() {
      let randomNum = Math.floor(Math.random() * 50) + 50;
      return `${randomNum}%`;
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
